import { useState, useEffect, useCallback, useRef } from 'react';

/**
 * AKM POC §7.2/§7.4 — yeni PDKS rapor listelerinin (Personel Devam Kartı, Vardiya Raporu, Plan–Gerçekleşen Sapma) ortak
 * veri kancası: useTaReportApi ile aynı sözleşme (sayfalı PaginatedList; tablo durumu → queryParams). api.js GET'te
 * reddetmez — başarısız yanıt (res.data.status === false; ör. taReport.rangeTooLong) boş liste olur, mesaj interceptor'da.
 */
export function useTaListFetch(fetchFn) {
  const [fetching, setFetching] = useState(true);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ totalRowCount: 0, pageSize: 10, pageIndex: 0 });
  const [queryParams, setQueryParams] = useState({ pageSize: 10, pageNumber: 1 });
  const [filterList, setFilterList] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const lastValidQueryParams = useRef(null);

  useEffect(() => {
    const paramsToUse = queryParams && Object.keys(queryParams).length > 0
      ? queryParams
      : lastValidQueryParams.current || { pageNumber: 1, pageSize: 10 };
    lastValidQueryParams.current = paramsToUse;
    let cancelled = false;
    setFetching(true);
    Promise.resolve(fetchFn(paramsToUse))
      .then((res) => {
        if (cancelled) return;
        if (res?.data?.status === false) {
          setData([]);
          setPagination({ totalRowCount: 0, pageSize: paramsToUse.pageSize || 10, pageIndex: 0 });
          return;
        }
        const result = res?.data?.data;
        const items = Array.isArray(result) ? result : (result?.data || []);
        setData(items);
        setPagination({
          totalRowCount: result?.totalRowCount || items.length,
          pageIndex: result?.pageIndex ? result.pageIndex - 1 : 0,
          pageSize: result?.pageSize || items.length || 10,
        });
      })
      .catch(() => { if (!cancelled) setData([]); })
      .finally(() => { if (!cancelled) setFetching(false); });
    return () => { cancelled = true; };
  }, [queryParams, refreshTrigger, fetchFn]);

  const refresh = useCallback(() => setRefreshTrigger((p) => p + 1), []);

  return {
    data, fetching, pagination, queryParams, setQueryParams, filterList, setFilterList, refresh,
  };
}

export default useTaListFetch;
